import React, { useEffect, useState } from "react";
import {
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import InboxRoundedIcon from "@mui/icons-material/InboxRounded";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { connect } from "react-redux";
import { fetchUltimoReportePistola } from "../../redux/actions/reportes";

const ListaReportesPuesto = ({
  data,
  fetchUltimoReportePistola,
  ultimoReporte,
}) => {
  useEffect(() => {
    const puestoId = data.puesto.id;
    fetchUltimoReportePistola(puestoId);
  }, []);

  if (!Object.keys(ultimoReporte).length) {
    return (
      <>
        <InboxRoundedIcon sx={{ color: "#cccccc" }} />
        <Typography sx={{ color: "#cccccc" }} variant="caption">
          Sin reportes
        </Typography>
      </>
    );
  }

  return (
    <>
      <List sx={{ borderStyle: "solid", borderWidth: 0.8, borderColor: "red" }}>
        <ListItem>
          <ListItemButton>
            <ListItemIcon>
              <SummarizeIcon />
            </ListItemIcon>
            <ListItemText
              primary={ultimoReporte.titulo}
              secondary={`${ultimoReporte.nombre_usuario} - ${ultimoReporte.fecha_creacion}`}
            />
          </ListItemButton>
        </ListItem>
      </List>

      <NavLink
        to="/reportes"
        sx={{ textDecoration: "underline red", cursor: "pointer" }}
      >
        <Typography
          sx={{
            mt: 2,
            color: "red",
          }}
        >
          Ver más reportes <OpenInNewIcon />{" "}
        </Typography>
      </NavLink>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ultimoReporte: state.reportes.utlimoReporte,
  };
};

export default connect(mapStateToProps, { fetchUltimoReportePistola })(
  ListaReportesPuesto
);
